export var canTrackingEmbeddedRoute = function (isLoginRoute, hasQueryParams) {
    if (isLoginRoute && !hasQueryParams)
        return false;
    return true;
};
